import { useClientCardStore } from '@/stores/client_card_store'
import { usePaymentCardStore } from '@/stores/payment_card_store'
import { useBusinessServiceCardStore } from '@/stores/business_service_card_store'
import { useBusinessServiceTypeCardStore } from '@/stores/business_service_type_card_store'
import { useBusinessServiceNameCardStore } from '@/stores/business_service_name_card_store'
import { useBookingTypeCardStore } from '@/stores/booking_type_card_store'
import { useGroupCardStore } from '@/stores/group_card_store'
import { useSubscriptionTypeCardStore } from '@/stores/subscription_type_card_store'
import { useAddClientFormStore } from '@/stores/add_client_form_store'
import { useAddPaymentFormStore } from '@/stores/add_payment_form_store'
import { useAddServiceCategoryFormStore } from '@/stores/add_service_category_form_store'
import { useAddServiceTypeFormStore } from '@/stores/add_service_type_form_store'
import { useAddSubscriptionTypeFormStore } from '@/stores/add_subscription_type_form_store'
import { useAddBusinessServiceFormStore } from '@/stores/add_business_service_form_store'
import { useAddBookingTypeFormStore } from '@/stores/add_booking_type_form_store'
import { useAddGroupFormStore } from '@/stores/add_group_form_store'

export type InfoViewSelectionKind =
  | 'client'
  | 'payment'
  | 'businessService'
  | 'businessServiceType'
  | 'businessServiceName'
  | 'bookingType'
  | 'group'
  | 'subscriptionType'
  | 'addClientForm'
  | 'addPaymentForm'
  | 'addServiceCategoryForm'
  | 'addServiceTypeForm'
  | 'addSubscriptionTypeForm'
  | 'addBusinessServiceForm'
  | 'addBookingTypeForm'
  | 'addGroupForm'

/**
 * Clear info-panel selections except the selection kind currently being set.
 *
 * Each feature keeps its own tiny selected-id store, but the rule that only
 * one info card should be visible belongs here. Future selectable tabs should
 * add their store to this helper instead of clearing peers ad hoc in tabs.
 */
export function clearInfoViewSelections(except?: InfoViewSelectionKind): void {
  if (except !== 'client') {
    useClientCardStore().clearSelection()
  }
  if (except !== 'payment') {
    usePaymentCardStore().clearSelection()
  }
  if (except !== 'businessService') {
    useBusinessServiceCardStore().clearSelection()
  }
  if (except !== 'businessServiceType') {
    useBusinessServiceTypeCardStore().clearSelection()
  }
  if (except !== 'businessServiceName') {
    useBusinessServiceNameCardStore().clearSelection()
  }
  if (except !== 'bookingType') {
    useBookingTypeCardStore().clearSelection()
  }
  if (except !== 'group') {
    useGroupCardStore().clearSelection()
  }
  if (except !== 'subscriptionType') {
    useSubscriptionTypeCardStore().clearSelection()
  }
  if (except !== 'addClientForm') {
    useAddClientFormStore().close()
  }
  if (except !== 'addPaymentForm') {
    useAddPaymentFormStore().close()
  }
  if (except !== 'addServiceCategoryForm') {
    useAddServiceCategoryFormStore().close()
  }
  if (except !== 'addServiceTypeForm') {
    useAddServiceTypeFormStore().close()
  }
  if (except !== 'addSubscriptionTypeForm') {
    useAddSubscriptionTypeFormStore().close()
  }
  if (except !== 'addBusinessServiceForm') {
    useAddBusinessServiceFormStore().close()
  }
  if (except !== 'addBookingTypeForm') {
    useAddBookingTypeFormStore().close()
  }
  if (except !== 'addGroupForm') {
    useAddGroupFormStore().close()
  }
}
